import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGmailLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M1.09094 12.2401H3.63637V6.05834L0 3.33105V11.1493C0 11.752 0.488187 12.2402 1.09094 12.2402V12.2401Z",
						fill: "#4285F4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M12.3633 12.2401H14.9088C15.5115 12.2401 15.9997 11.752 15.9997 11.1492V3.33105L12.3633 6.05834V12.2401Z",
						fill: "#34A853"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M12.3633 1.33114V6.05842L15.9997 3.33114V1.87661C15.9997 0.528425 14.4606 -0.241575 13.3815 0.567519L12.3633 1.33114Z",
						fill: "#FBBC04"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.63672 6.05834V1.33105L8.00034 4.6038L12.364 1.33105V6.05834L8.00034 9.33105L3.63672 6.05834Z",
				fill: "#EA4335"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M0 1.87661V3.33115L3.63637 6.05843V1.33115L2.61819 0.56752C1.53906 -0.241574 0 0.528426 0 1.87655V1.87661Z",
				fill: "#C5221F"
			})
		]
	})
});
export { SvgGmailLogo as ReactComponent };
